import React from 'react'
import PropTypes from 'prop-types'

import BoxRounded from '../../commons/BoxRounded/BoxRounded'
import Flex from '../../commons/Flex/Flex'
import Phone from '../../commons/Icons/Phone'
import Text from '../../commons/Text/Text'

import styles from './detailStore.module.scss'

const DetailStoreContact = ({
  email,
  phoneNumber,
  phoneNumberDdd,
  website
}) => {
  return (
    <BoxRounded>
      <Flex style={{ rowGap: 30 }}>
        <div className={styles.icon}>
          <Phone />
        </div>
      </Flex>
      <Flex column>
        <Text size="sm" color="gray" variation="dark" bold margin="18px 0 11px">
          Telefone
        </Text>
        <Text color="gray" variation="dark" font="custom" size="xxs">
          {`(${phoneNumberDdd})`} {phoneNumber}
        </Text>
      </Flex>

      {email && (
        <Flex column>
          <Text
            size="sm"
            color="gray"
            variation="dark"
            bold
            margin="18px 0 11px"
          >
            E-mail
          </Text>
          <Text color="gray" variation="dark" font="custom" size="xxs">
            {email}
          </Text>
        </Flex>
      )}

      {website && (
        <Flex column>
          <Text
            size="sm"
            color="gray"
            variation="dark"
            bold
            margin="18px 0 11px"
          >
            Site
          </Text>
          <Text color="gray" variation="dark" font="custom" size="xxs">
            {website}
          </Text>
        </Flex>
      )}
    </BoxRounded>
  )
}

DetailStoreContact.defaultProps = {
  email: null,
  website: null
}

DetailStoreContact.propTypes = {
  email: PropTypes.string,
  phoneNumber: PropTypes.string.isRequired,
  phoneNumberDdd: PropTypes.string.isRequired,
  website: PropTypes.string
}

export default DetailStoreContact
